export default "__VITE_ASSET__D4CwjNUE__"